import { createContext, useContext, useState, type ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { Household } from '@ousse/shared'
import { api } from './api'
import { useHouseholdRealtime } from './realtime'
import { readLocal, writeLocal } from './storage'

const KEY = 'ousse.householdId'

interface HouseholdState {
  households: Household[]
  current: Household | null
  select: (id: string) => void
  loading: boolean
}

const HouseholdContext = createContext<HouseholdState | null>(null)

/** Foyer affiché : choix mémorisé dans ce navigateur, sinon le premier foyer. */
export function HouseholdProvider({ children }: { children: ReactNode }) {
  const [selected, setSelected] = useState<string | null>(() => readLocal(KEY))
  const query = useQuery({ queryKey: ['households'], queryFn: () => api.get<{ items: Household[] }>('/households') })
  const households = query.data?.items ?? []
  const current = households.find((h) => h.id === selected) ?? households[0] ?? null
  const select = (id: string) => {
    setSelected(id)
    writeLocal(KEY, id)
  }
  return (
    <HouseholdContext.Provider value={{ households, current, select, loading: query.isPending }}>
      <RealtimeBridge />
      {children}
    </HouseholdContext.Provider>
  )
}

function RealtimeBridge() {
  useHouseholdRealtime()
  return null
}

export function useHousehold() {
  const ctx = useContext(HouseholdContext)
  if (!ctx) throw new Error('useHousehold hors de HouseholdProvider')
  return ctx
}
